import {gql} from 'apollo-angular';

export const GET_TEACHING_IDEAS = gql`
  query GetTeachingIdeas($classId: Int!) {
    getTeachingIdeas(schoolClassID: $classId) {
      implementedAt
      difficulties
      worksWell
      note
      status
      type {
        id
        typeName
      }
    }
  }
`;
